import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import Utils from '../../../utils';
import Logger from '../../../lib/analytics/logger';
import HTTP from '../../../utils/httpMethods';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import { setPlayerInfo } from '../../actions/playerInfo';
import { handleQueryLoggerEvents } from '../handleLoggerErrorEvents';
import { Endpoints } from '../../../api/Constants';
import { validateJson } from '../../../utils/jsonschema/validator';
import { PLAYER_TAGS } from '../tags';
export var getPlayerProfileQuery = {
  query: function query() {
    return {
      url: Endpoints.GET_PLAYER_PROFILE
    };
  },
  transformResponse: function transformResponse(response) {
    var _response$;
    if (!(response !== null && response !== void 0 && response[0]) || (response === null || response === void 0 || (_response$ = response[0]) === null || _response$ === void 0 ? void 0 : _response$.success) === false) return response;
    if (validateJson(Endpoints.GET_PLAYER_PROFILE, response)) return response[0];
  },
  providesTags: [PLAYER_TAGS.GET_PLAYER_PROFILE],
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args, _ref) {
      var dispatch, queryFulfilled, getState, _yield$queryFulfilled, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled, getState = _ref.getState;
            _context.prev = 1;
            _context.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled = _context.sent;
            data = _yield$queryFulfilled.data;
            dispatch(setPlayerInfo({
              name: data.name,
              playerId: data.playerId,
              email: data.email,
              emailOptIn: data.emailOptIn === 'yes',
              casinoId: data.casinoId
            }));
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            handleQueryLoggerEvents(_context.t0, getState, Endpoints.GET_PLAYER_PROFILE);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postUpdatePlayerProfileMutation = {
  query: function query(data) {
    return {
      url: Endpoints.UPDATE_PLAYER_PROFILE,
      method: 'post',
      body: {
        data: _objectSpread({
          platform: Utils.getPlatform(),
          launch_type: Utils.getSource()
        }, data)
      }
    };
  },
  transformResponse: function transformResponse(response) {
    if (validateJson(Endpoints.UPDATE_PLAYER_PROFILE, response, HTTP.POST)) return response[0];
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(args, _ref2) {
      var dispatch, queryFulfilled, getState, _yield$queryFulfilled2, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled, getState = _ref2.getState;
            _context2.prev = 1;
            _context2.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled2 = _context2.sent;
            data = _yield$queryFulfilled2.data;
            if (!data.success) {
              _context2.next = 9;
              break;
            }
            _context2.next = 9;
            return dispatch(getPlayerProfileQuery.initiate()).unwrap();
          case 9:
            _context2.next = 14;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            handleQueryLoggerEvents(_context2.t0, getState, Endpoints.UPDATE_PLAYER_PROFILE);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 11]]);
    }));
    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }
    return onQueryStarted;
  }(),
  invalidatesTags: [PLAYER_TAGS.GET_PLAYER_PROFILE]
};
export var getCasinoDollarBalanceQuery = {
  query: function query() {
    return {
      url: Endpoints.GET_CASINO_DOLLAR_BALANCE
    };
  },
  transformResponse: function transformResponse(response) {
    var _response$2;
    if (!(response !== null && response !== void 0 && response[0]) || (response === null || response === void 0 || (_response$2 = response[0]) === null || _response$2 === void 0 ? void 0 : _response$2.success) === false) return response;
    if (validateJson(Endpoints.GET_CASINO_DOLLAR_BALANCE, response)) return response[0];
  },
  providesTags: [PLAYER_TAGS.CASINO_DOLLAR_BALLANCE]
};
export var getToggleSoundMutation = {
  query: function query() {
    return {
      url: Endpoints.TOGGLE_SOUND
    };
  },
  transformResponse: function transformResponse(response) {
    var _response$3;
    if (!(response !== null && response !== void 0 && response[0]) || (response === null || response === void 0 || (_response$3 = response[0]) === null || _response$3 === void 0 ? void 0 : _response$3.success) === false) return response;
    if (validateJson(Endpoints.TOGGLE_SOUND, response)) return response[0];
  },
  invalidatesTags: [PLAYER_TAGS.GET_PLAYER_PROFILE]
};
export var getToggleMusicMutation = {
  query: function query() {
    return {
      url: Endpoints.TOGGLE_MUSIC
    };
  },
  transformResponse: function transformResponse(response) {
    var _response$4;
    if (!(response !== null && response !== void 0 && response[0]) || (response === null || response === void 0 || (_response$4 = response[0]) === null || _response$4 === void 0 ? void 0 : _response$4.success) === false) return response;
    if (validateJson(Endpoints.TOGGLE_MUSIC, response)) return response[0];
  },
  invalidatesTags: [PLAYER_TAGS.GET_PLAYER_PROFILE]
};
export var postChangePasswordMutation = {
  query: function query(_ref3) {
    var newPassword = _ref3.newPassword,
      oldPassword = _ref3.oldPassword;
    return {
      url: Endpoints.CHANGE_PASSWORD,
      method: 'post',
      body: {
        data: {
          oldPassword: oldPassword,
          newPassword: newPassword,
          platform: Utils.getPlatform(),
          launch_type: Utils.getSource()
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response[0];
  },
  onQueryStarted: function () {
    var _onQueryStarted3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(args, _ref4) {
      var queryFulfilled, _yield$queryFulfilled3, response, eventPayload;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            queryFulfilled = _ref4.queryFulfilled;
            _context3.next = 3;
            return queryFulfilled;
          case 3:
            _yield$queryFulfilled3 = _context3.sent;
            response = _yield$queryFulfilled3.data;
            if (!response.success) {
              eventPayload = {
                endpoint: Endpoints.CHANGE_PASSWORD,
                description: "Change password failed, ".concat(response === null || response === void 0 ? void 0 : response.error),
                code: response === null || response === void 0 ? void 0 : response.error_code
              };
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, eventPayload);
            }
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function onQueryStarted(_x5, _x6) {
      return _onQueryStarted3.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postRecoverPasswordTokenCheckMutation = {
  query: function query(_ref5) {
    var id = _ref5.id,
      token = _ref5.token;
    return {
      url: Endpoints.RECOVER_PASSWORD_TOKEN_CHECK,
      method: 'post',
      body: {
        data: {
          id: id,
          token: token,
          platform: Utils.getPlatform(),
          launch_type: Utils.getSource()
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(args, _ref6) {
      var queryFulfilled, _yield$queryFulfilled4, response, eventPayload;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            queryFulfilled = _ref6.queryFulfilled;
            _context4.next = 3;
            return queryFulfilled;
          case 3:
            _yield$queryFulfilled4 = _context4.sent;
            response = _yield$queryFulfilled4.data;
            if (!response.success) {
              eventPayload = {
                endpoint: Endpoints.RECOVER_PASSWORD_TOKEN_CHECK,
                description: "Check recover password failed, ".concat(response.error),
                code: response.error_code
              };
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, eventPayload);
            }
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function onQueryStarted(_x7, _x8) {
      return _onQueryStarted4.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postRecoverPasswordMutation = {
  query: function query(_ref7) {
    var id = _ref7.id,
      token = _ref7.token,
      password = _ref7.password;
    return {
      url: Endpoints.RECOVER_PASSWORD,
      method: 'post',
      body: {
        data: {
          id: id,
          token: token,
          password: password,
          platform: Utils.getPlatform(),
          launch_type: Utils.getSource()
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(args, _ref8) {
      var queryFulfilled, _yield$queryFulfilled5, response, eventPayload;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            queryFulfilled = _ref8.queryFulfilled;
            _context5.next = 3;
            return queryFulfilled;
          case 3:
            _yield$queryFulfilled5 = _context5.sent;
            response = _yield$queryFulfilled5.data;
            if (!response.success) {
              eventPayload = {
                endpoint: Endpoints.RECOVER_PASSWORD,
                description: "Check recover password failed, ".concat(response.error),
                code: response.error_code
              };
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, eventPayload);
            }
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function onQueryStarted(_x9, _x10) {
      return _onQueryStarted5.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postAcceptNewTermsMutation = {
  query: function query() {
    return {
      url: Endpoints.ACCEPT_NEW_TERMS,
      method: 'post'
    };
  },
  transformResponse: function transformResponse(response) {
    return response[0];
  }
};
export var getDeletePlayerAccountMutation = {
  query: function query() {
    return {
      url: Endpoints.DELETE_PLAYER_ACCOUNT
    };
  },
  transformResponse: function transformResponse(response) {
    var _response$5;
    if (!(response !== null && response !== void 0 && response[0]) || (response === null || response === void 0 || (_response$5 = response[0]) === null || _response$5 === void 0 ? void 0 : _response$5.success) === false) return response;
    if (validateJson(Endpoints.DELETE_PLAYER_ACCOUNT, response)) return response[0];
  }
};